import { Component, Input } from '@angular/core';
import { InvoiceStateColor, InformerPosition } from '../../../services/invoices/invoice-states.config';
import { dateToString } from '@shared/utils/date.util';
import { DatePipe } from '@angular/common';
import { ToDateFormatPipe } from '../../../pipes/to-date-format.pipe';

@Component({
  selector: 'app-invoice-progress-state',
  templateUrl: './invoice-progress-state.component.html',
  styleUrls: ['./invoice-progress-state.component.scss'],
})
export class InvoiceProgressStateComponent {
  protected readonly classPrefix = 'invoice-progress-state';

  @Input() informerPosition: InformerPosition;
  @Input() informerIcon: string = '';
  @Input() informerText: string = '';
  @Input() informerDate: string = '';
  @Input() showNote: boolean = false;
  @Input() stateColor: InvoiceStateColor = 'gray';
  @Input() progressPercent: number = 0;
  @Input() startLocation: string = '';
  @Input() endLocation: string = '';
  @Input() dateFirstDayStorage: string = '';
  @Input() dateReturnCargo: string = '';

  addOneDayToDate(date: string): string {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return dateToString(newDate);
  }

  get getNote(): string {
    if (this.dateFirstDayStorage) {
      const dateFirstDayStorage = new DatePipe('en-US').transform(
        new ToDateFormatPipe().transform(this.dateFirstDayStorage),
        'dd.MM.yyyy',
      );
      return `Платне зберігання з: ${dateFirstDayStorage}`;
    }

    if (this.dateReturnCargo) {
      return `Автоповернення ${this.addOneDayToDate(this.dateReturnCargo)}`
    }

    return '';
  }

  get isCompletedProgress(): boolean {
    return this.progressPercent === 100;
  }

  get progressBackgroundSize(): string {
    return `100% ${this.progressPercent}%`;
  }

  get stateColorClass(): string {
    return `${this.classPrefix}-${this.stateColor}`;
  }

  get isStartPosition(): boolean {
    return this.informerPosition === InformerPosition.Start;
  }

  get isEndTopPosition(): boolean {
    return this.informerPosition === InformerPosition.EndTop;
  }

  get isEndBottomPosition(): boolean {
    return this.informerPosition === InformerPosition.EndBottom;
  }
}
